<div style="display: flex; width: 100%; height: 90vh">
  <div style="width: 25%; display: flex; flex-direction: column; align-items: center; height: 100%">
    <div style="display: flex; flex-direction: row; padding: 10px; width: 100%">
      <button (click)="onCreateBlog()" class="btn btn-success" style="margin: 10px; width: 50%">New Blog</button>
      <kendo-dropdownlist
        [data]="blogFilters"
        [valueField]="'id'"
        [textField]="'name'"
        (selectionChange)="onFilterChange($event)"
        [(ngModel)]="selectedFilter"
        style="margin: 10px; width: 50%"
      ></kendo-dropdownlist>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; width: 100%; overflow-y: auto">
      @for (blog of getFilteredBlogs(); track blog.id) {
        <div style="width: 100%; display: flex; flex-direction: row">
          <button (click)="switchBlog(blog, true)" class="btn btn-primary" style="margin: 10px; margin-left: 20px; width: 220px; height: fit-content;"
            [ngStyle]="blog.id === selectedBlog.id && {'color': 'black', 'border-color': 'black'}">{{blog.name}}</button>
          @switch (blog.status) {
            @case (0) {
              <div style="margin-top: 22px">Draft</div>
            }
            @case (1) {
              <div style="margin-top: 22px">Published</div>
            }
          }
        </div>
      }
    </div>
  </div>
  <div style="width: 55%; padding: 20px; overflow-y: auto">
    <div style="align-items: center; display: flex; flex-direction: column">
      @if (createBlog) {
        <kendo-textbox [(ngModel)]="selectedBlog.name" placeholder="Blog Name" style="max-width: 300px; margin-top: 150px"></kendo-textbox>
        <button class="btn btn-primary" style="margin: 10px" (click)="insertBlog()">Create Blog</button>
      } @else {
        <kendo-textbox [(ngModel)]="selectedBlog.name" style="width: fit-content; margin: 10px"></kendo-textbox>
        <div style="font-size: large; font-weight: bold">Header</div>
        <div style="display: flex; flex-direction: row; margin-bottom: 30px">
          @if (blogHeaderImage !== "") {
          <img src="{{blogHeaderImage}}" style="width: 300px; height: 100px; margin-right: 10px">
          }
          <div style="background-color: white; max-height: 100px;">
            <ngx-editor-menu [editor]="headerEditor" [toolbar]="toolbar"></ngx-editor-menu>
            <ngx-editor [spellcheck]="false" [editor]="headerEditor" [(ngModel)]="blogHeader" (ngModelChange)="onContentChange()"></ngx-editor>
          </div>
        </div>
        <div style="font-size: large; font-weight: bold">Content</div>
        <div style="background-color: white">
          <ngx-editor-menu [editor]="contentEditor" [toolbar]="toolbar"></ngx-editor-menu>
          <ngx-editor [spellcheck]="false" [editor]="contentEditor" [(ngModel)]="blogContent" (ngModelChange)="onContentChange()"></ngx-editor>
        </div>
      }
    </div>
  </div>
  @if (!createBlog) {
    <div style="width: 20%; display: flex; flex-direction: column; align-items: center; padding: 10px">
        <div style="display: flex; flex-direction: row; margin-bottom: 20px">
          <button class="btn btn-success" style="margin: 5px" (click)="onSaveClick()">Save</button>
          <button class="btn btn-primary" style="margin: 5px" (click)="publishBlog()">{{selectedBlog.status === 1 ? 'Unpublish' : 'Publish'}}</button>
          <button class="btn btn-danger" style="margin: 5px" (click)="onDeleteButtonClick(deleteModal)">Delete</button>
        </div>
        <div style="font-size: medium; font-weight: bold">Languages</div>
        <div style="display: flex; flex-direction: row; margin-bottom: 20px">
          <div style="font-size: medium; font-weight: 500; margin-top: 10px; margin-right: 4px">Language:</div>
          <kendo-dropdownlist
            [data]="languages"
            [valueField]="'id'"
            [textField]="'name'"
            (selectionChange)="onLanguageChange($event)"
            [(ngModel)]="selectedLanguage"
          ></kendo-dropdownlist>
        </div>
        <div style="font-size: medium; font-weight: bold">Images</div>
        <input type="file" id="selectedFile" (change)="uploadImage($event)" style="display: none">
        <input type="button" class="btn btn-primary" value="Upload Image" onclick="document.getElementById('selectedFile').click()" style="margin-bottom: 10px">
        <div style="display: flex; flex-direction: column; align-items: center; width: 100%; overflow-y: auto">
          @for (image of availableImages; track image.id) {
            <div style="display: flex; flex-direction: row">
              <button class="btn btn-primary" (click)="setImageAsHeader(image)" style="padding: 5px; font-size: small; margin-right: 10px; height: 50px; width: 60px; margin-top: 35px; display: flex; text-align: center;">Set Header</button>
              <button (click)="onImageSelect(image)" style="width: 100px; height: 100px; margin: 5px; min-height: 100px; min-width: 100px">
                <img src={{image.imageUrl}} style="width: 100%; height: 100%">
              </button>
            </div>
          }
        </div>
    </div>
  }
</div>

<ng-template #deleteModal let-modal>
  <div class="modal-header" style="display: block">
    <div style="font-size: xx-large; justify-self: center">Delete Blog</div>
  </div>
  <div class="modal-body" style="text-align: center;">
    <div style="font-size: large">Are you sure you want to delete the following blog?</div>
    <div style="font-size: large; font-weight: 700">{{selectedBlog.name}}</div>
  </div>
  <div class="modal-footer" style="justify-content: space-around">
    <button type="button" class="btn btn-outline-secondary"
      (click)="modal.dismiss('cancel click')">Cancel</button>
    <button type="button" class="btn btn-danger"
      (click)="onDeleteConfirm()">Confirm</button>
  </div>
</ng-template>
